module.exports = __webpack_public_path__ + "static/media/ic_st_b3_myway.d43d301a.svg";